import { Navigate, useLocation } from 'react-router-dom';
import { resolvePathRedirect } from '../seo/legacyRedirects';
import NotFoundPage from './NotFoundPage';

function RedirectOrNotFound() {
  const location = useLocation();
  const target = resolvePathRedirect(location.pathname);

  if (target) {
    return <Navigate to={`${target}${location.search}`} replace />;
  }

  return <NotFoundPage />;
}

export default RedirectOrNotFound;
